<template>
	<div class="register_wrap">
	<div class="mainre">
		<div class="register_bg">
			<div class="register_main">
				<h3>欢迎注册DataGalaxy帐号</h3>
				<div class="registerdiv registerphone">
					<input type="text" @blur="phoneVerification" placeholder="手机号" v-model="phone" />
					<span id="registerphonem"></span>
				</div>
				<div class="registerdiv verification">
					<input type="text" @blur="verificationVerification" placeholder="验证码" v-model="verification" />
					<span class="code" @click="refreshCode">
    					<Sidentify :identifyCode="identifyCode"></Sidentify>
  					</span>
					<a @click="refreshCode">换一张</a>
					<span id="verificationm" ></span>
				</div>
				<div class="registerdiv phone_verification">
					<input type="text" name="aa" placeholder="短信验证码" v-model="SMSverification" />
					<a v-if="timer_flag" style="cursor: pointer;" @click="getCode">{{codeStr}}</a>
					<a v-if="!timer_flag" style="cursor: pointer;background: #D3D4D6;" @click="getCode">{{codeStr}}</a>
					<span id="SMSmes"></span>
				</div>
				<div class="registerdiv password">
					<input type="password" v-model="password" placeholder="请输入6~16位数字、字母组合的密码" @blur="passwordVerification" />
					<span id="passwordm"></span>
				</div>
				<div class="registerdiv cue_password">
					<input type="password"  placeholder="请再次输入密码" @blur='cuePassword' v-model="cue_password" />
					<span id="cue_passwordm"></span>

				</div>
				<div class="registerdiv yourname">
					<input type="text"  placeholder="您的称呼" />
					<span ></span>
				</div>
				<div class="registerdiv yourposition">
					<input type="text"  placeholder="您的工作单位" />
					<span ></span>
				</div>
				<div class="registerdiv agree_with" style="text-align: left;">
					<span class="agreebox" ><input v-model="agree"  type="checkbox" /></span>阅读并同意
					<a style="color: #076bf2;cursor: pointer;" @click="readAgreements">平台用户协议</a>
					<span id="agreemes" ></span>
				</div>
				<div class="registerdiv registerbtn">
					<a class="r_b"  @click="SMSVerification">注册</a>
				</div>
			</div>
		</div>
		</div>
		<!-- 用户协议 -->
		<div id="agreement_pop" v-show="agreement_flag">
			<div class="agreement_main" >
				<div class="agreement_title">
					用户协议
					<div @click="closeAgreements" style="line-height: 2;" class="agreement_close el-icon-close">
						
					</div>
				</div>
				<div class="agreement_content" v-html="agreement_rdt">
					
				</div>
				<div class="agreement_bottom">
					<span @click="acceptAgreements">
						我接受
					</span>
					<span @click="nonAcceptAgreements">
						我不接受
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Sidentify from '@/components/identify.vue'
	export default {
		data() {
			return {
				agreement_rdt:``,
				agreement_flag:false,
				apiUrl:this.apiUrl,
				agreemes:'',//用户协议提示信息
				agree:true,//有无阅读用户协议
				phone: '',//手机号
				verification: '',//图形验证
				SMSverification: '',//短信验证
				password: '',//密码
				cue_password: '',//确认密码
				username: '',
				codeStr:'发送短信验证码',
				company: '',
				phone_flag: '',
				password_flag: '',
				username_flag: '',
				phone_verification_flag: '',
				verification_flag: '',
				cue_password_flag: '',
				user_agreement_flag: '',
				identifyCodes: "01234567890abcdefghijklmnopqrstuvwxyz",
				identifyCode: "",
				timer_flag:true,
				phoneCode:'',		//手机验证码
			}
		},
		destoryed(){
			if(timer){
				window.clearInterval(timer);
			}
		},
		beforeRouteLeave(to, from, next) {
        	let ele1=document.getElementById('home_register_button');
				let ele=document.getElementById('home_login_button');
				ele1.style.background='#080C18';
				ele1.style.color='#076BF2';
				ele.style.background='#076BF2';
				ele.style.color='white';
				if (to.path == "/yonghuxieyi") {
					from.meta.keepAlive = true;
	 			}else{
	 				from.meta.keepAlive = false;
	 			}
				next();
   			},
		mounted() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);
		},
		methods: {
			//关闭用户协议
			closeAgreements() {
				this.agreement_flag = false;
			},
			//接受用户协议
			acceptAgreements() {
				this.agreement_flag = false;
				this.agree = true;
			},
			//不接受用户协议
			nonAcceptAgreements() {
				this.agreement_flag = false;
				this.agree = false;
			},
			//阅读用户协议
			readAgreements() {
			let that=this;
			that.agreement_flag = true;
			that.$http.get(
//				'http://39.104.14.210/dataGalaxy/index.php?m=Api&c=content&a=user_agreement',
				that.apiUrl+'index.php?m=Api&c=content&a=user_agreement',
			).then(response => {

						//进行数据验证
						if(response.body.status != 1){
							//显示错误页面
							
							return;
						}
						
						if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
							
							//显示空数据页面
							this.$message({
								message: '暂无数据',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
							return;
						}
						this.agreement_rdt = response.body.data.content;
						

			}, response => {

			});
			},
			// 手机号验证 
			phoneVerification() {
				let that = this;
				let message = document.getElementById('registerphonem')
				let reg = /^1[3-9]{1}[0-9]{9}$/;
				if(that.phone) {
					if(reg.test(that.phone)) {
						that.phone_flag = 1;
						message.innerText = '';
						return true;
					} else {
						that.phone_flag = '';
						message.innerText = '请输入正确的手机号'
						return false;
					}
				} else {
					that.phone_flag = '';
					message.innerText = '手机号不能为空'
					return false;
				}
			},
			// 验证码验证
			verificationVerification() {
				let that = this;
				let message = document.getElementById('verificationm')
				if(that.verification) {
					if(that.verification==that.identifyCode) {
						that.verification_flag = 1;
						message.innerText = '';
						return true;
					} else {
						that.verification_flag = '';
						message.innerText = '验证码错误'
						return false;
					}
				} else {
					that.verification_flag = '';
					message.innerText = '验证码不能为空'
					return false;
				}
			},
			startTime(time){
				let _that=this;
				let timer = setInterval(() => {
					time--
					if(time == 0){
						_that.timer_flag = true;
						_that.codeStr = '发送短信验证码'
						clearInterval(timer)
					}else{
						_that.codeStr = time + 's后重新发送'
						_that.timer_flag = false
					}
				},1000)
			},
			//手机短信验证
			SMSVerification() {
				let _this=this;
				let message = document.getElementById('SMSmes')
				if(_this.SMSverification){
					_this.$http.get(_this.apiUrl+'index.php?m=Api&c=Login&a=verifyCode', {
						params: {
							'phone': _this.phone,
							'code': _this.SMSverification
						}
					}).then(
						response => {
							//进行数据验证
							if(response.body.status=='1'){
								_this.phone_verification_flag = true;
								_this.dgregister();
								return;
							}
							if(response.body.status=='2'){
							message.innerText='验证码错误';
							_this.phone_verification_flag = '';
								return false;
							};
							if(response.body.status=='3'){
							message.innerText='验证码失效';
							_this.phone_verification_flag = '';
								return false;
							}
						},
						response => {
//							console.log('error');
						}
					);
				}else{
					message.innerText='请输入短信验证码';
					_this.phone_verification_flag = '';
					return false;
				}
			},
			//密码验证
			passwordVerification() {
				let that = this;
				let message = document.getElementById('passwordm')
				let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				if(that.password) {
					if(reg.test(that.password)) {
						that.password_verification_flag = 1;
						message.innerText = '';
						return true;
					} else {
						that.password_verification_flag = '';
						message.innerText = '密码格式错误';
						return false;
					}
				} else {
					that.password_verification_flag = '';
					message.innerText = '密码不能为空';
					return false;
				}
			},
			//确认密码
			cuePassword() {				
				let message = document.getElementById('cue_passwordm')
				let that = this;
				if(that.cue_password){
					if(that.password !== that.cue_password) {
					message.innerText = '两次密码不一致';
					return false;
				} else {
					message.innerText = '';
					that.cue_password_flag=1;
					return true;
				}
				}else{
					message.innerText = '请确认密码';
					that.cue_password_flag='';
					return false;
				}
			},
			//提交注册
			dgregister(){
				let _that=this;
				_that.phoneVerification();
				_that.passwordVerification();
				_that.cuePassword();
				_that.verificationVerification()
				//进行数据验证
				if(_that.phone_flag&&_that.password_verification_flag&&_that.cuePassword()&&_that.verification_flag&&_that.agree){
				
					//执行注册
				_that.$http.get(
					_that.apiUrl+'index.php?m=Api&c=login&a=register',
					{
						params: {  
							"phone":_that.phone,
							'password':_that.password,
							'username':_that.username,
							'company':_that.company,
						}  
					}
				).then(response => {
					
					//进行数据验证
					if(response.body.status != 1){
						
						//显示错误页面
//						alert(response.body.message);
						
						_that.$message({
								message: response.body.message,
								type: 'warning',
								customClass: 'message-warning',
							});
						return;
					
					}else{
						_that.$message({
								message: '注册成功',
								type: 'success',
								customClass: 'message-warning',
							});
						_that.$router.push({
							path: '/enterPage',
					          query: {
					            're_phone': _that.phone
					          }
							});
					}
					
				}, response => {
//					console.log("error");
				});
				}
				
			},
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
			},
			makeCode(o, l) {
				for(let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					];
				}
			},
			//阅读用户协议
//			readagreements(){
//				
//			},
			//发送验证码
			getCode(){
				let _this=this;
				//验证手机号和图形验证码
				if(_this.phoneVerification() && _this.verificationVerification()){
					//发送验证码
					if(_this.timer_flag){
						_this.timer_flag=false;
						_this.$http.get(
						_this.apiUrl+'index.php?m=Api&c=login&a=sendCode',
						{
							params: {  
								"phone":_this.phone,
								'type':'1'
							}  
						}
					).then(response => {
						//进行数据验证
						if(response.body.status != 1){
							//显示错误页面
							if(response.body.message=='用户已存在'){
								_this.$message({
								message: '用户已存在,请直接登录',
								type: 'warning',
								customClass: 'message-warning',
								});
							_this.$router.push({
								name: 'enterPage',
								params:{
										'phone':_this.phone
									}
								})
							}
							return;
						}
						_this.startTime(60);
						_this.phoneCode = response.body.data.code;
								_this.$message({
								message: '验证码发送成功',
								type: 'success',
								customClass: 'message-warning',
								});
					}, response => {
//						console.log("error");
					});
					}
				}
				
				
			}
		},
		components: {
			Sidentify
		},
	}
</script>

<style>
	.agreebox{
		margin-right: 5px;
	}
	.r_b{
		width: 355px;height: 38px;line-height: 38px;background: #0671F2;color: white;display: block;border-radius: 4px;font-size: 18px;cursor: pointer;
	}
	.agreebox>input{
		width: 14px;
		height: 14px;
	}
	#agreemes,#cue_passwordm,#passwordm,#SMSmes,#verificationm,#registerphonem{
		height: 20px;
		line-height: 20px;
		color: red;
		float: left;
		width: 100%;
		text-align: left;
	}
	.yourposition>input,.yourname>input,.cue_password>input, .password>input{
		width: 348px;
	}
	.register_bg {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 1200px;
		height: 688px;
		background: white;
	}
	
	.register_main {
		width: 350px;
		margin: 0 auto;
	}
	
	.register_main>h3 {
		font-size: 28px;
		height: 120px;
		line-height: 120px;
		color: #333333;
	}
	
	.register_main>.registerdiv {
		height: 60px;
		width: 350px;
	}
	
	.register_main>.registerdiv>input {
		border-radius: 4px;
		float: left;
		text-indent: 10px;
		height: 38px;
		border: 1px solid #CCCCCC;
	}
	
	.register_main>.registerdiv>span {
		height: 20px;
		line-height: 20px;
		color: red;
	}
	.register_wrap{
		background: #F3F3F3;
		height: 100%;
	}
	.mainre{
		position: relative;
		padding-top: 60px;
		width: 100%;
		height: calc(100% - 101px);
	}
	.register_wrap .register_main>.registerphone>input {
		width: 348px;
	}
	
	.register_wrap .register_main>.verification>input {
		width: 160px;
	}
	
	.register_wrap .register_main>.verification>span {
		float: left;
		width: 107px;
		display: block;
		height: 40px;
		line-height: 40px;
		margin: 0 11px;
		border-radius: 4px;
	}
	
	.register_wrap .register_main>.verification>a {
		width: 66px;
		line-height: 40px;
		border-radius: 4px;
		cursor: pointer;
		color: #076bf2;
	}
	.register_wrap .register_main>.verification #verificationm{
		margin: 0;
	}
	.register_wrap .register_main>.phone_verification>input {
		float: left;
		width: 108px;
		height: 38px;
	}
	
	.register_wrap .register_main>.phone_verification>a {
		float: left;
		margin-left: 10px;
		width: 227px;
		height: 40px;
		line-height: 40px;
		color: white;
		background: #076BF2;
		border-radius: 4px;
		font-size: 16px;
	}
	#s-canvas{
		width: 100px;
		height: 40px;
	}
	#agreement_pop{
		background: rgba(0,0,0,.5);
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		z-index: 999;
	}
	.agreement_main{
		position: relative;
		padding: 60px 40px;
		width: 70%;
		height: 70%;
		margin: 5% auto;
		background: #fff;
		text-align: left;
	}
	.agreement_title{
		position: absolute;
		top: 0;
		left: 0;
		line-height: 60px;
		text-align: center;
		font-size: 24px;
		height: 60px;
		width: 100%;
	}
	.agreement_close{
		width: 40px;
		height: 60px;
		font-size: 30px;
		
		position: absolute;
		right: 10px;
		top: 0;
		cursor: pointer;
		text-align: center;
	}
	.agreement_content{
		padding: 0 15px;
		height: 100%;
		overflow: auto;
		background: #EFF1FD;
	}
	.agreement_bottom{
		line-height: 60px;
	 	position: absolute;
		bottom: 0;
		left: 0;
		height: 60px;
		width: 100%;
		text-align: center;
	}
	.agreement_bottom>span{
		cursor: pointer;
		/*padding: 10px;*/
		height: 32px;
		width: 120px;
		margin: 0 30px;
		text-align: center;
		line-height: 32px;
		padding: 0 10px;
		display: inline-block;
		background: #076bf2;
		border-radius: 16px;
		color: white;
	}
</style>


// WEBPACK FOOTER //
// src/register/registerPage.vue